<template>
  <div class="container clearfix">
    <div class="shadow-wrapper padding-m mb-m">
      <PasswordForm
        ref="passwordForm"
        title="密碼設定"
        :model="password"
      />
    </div>
    <div class="shadow-wrapper padding-m mb-m">
      <UserProfileForm
        ref="profileForm"
        title="會員基本資料"
        :model="profile"    
        :rules="signupRules"   
      >
        <template 
              slot="footer"
              slot-scope="props"
          >
          <AddressVueSelect
            v-model="props.profile.homeAddress"
            :label="`住所地址`"
            prop="address"
            :label-width="83"
          />
          <Checkbox
            v-model="same"
            @on-change="sameAsAddress"
            class="fz-tiny mb-xs"
            :style="{marginTop: '-26px'}"
          >
          同通訊地址
          </Checkbox>
          <BaseInput
          v-model="props.profile.reviewMail"
          label="Email確認"
          prop="reviewMail"
          placeholder="請再次輸入E-mail"         
          :label-width="83"
          type="email"
      />
        </template>
      </UserProfileForm>
    </div>
    <Button
      class="pull-right btn-m btn-primary"
      size="large"
      :loading="loading"
      :disabled="loading"
      @click="handleSubmit"
    >
      <span v-if="!loading">發送認證碼</span>
      <span v-else>請稍候</span>
    </Button>
  </div>
</template>

<script>
//import { mapState } from 'vuex';
  import { Button,Checkbox } from 'iview';
//  import axios, { generateAuthPostConf  } from '@/utils/axios';
  import PasswordForm from '@/components/forms/PasswordForm';
  import UserProfileForm from '@/components/forms/UserProfileForm';
  import AddressVueSelect from '@/components/forms/elements/AddressVueSelect';
  import { model as password } from '@/utils/asyncValidator/passwordForm';
  import { model as profile, devModel } from '@/utils/asyncValidator/userProfileForm';
  import BaseInput from '@/components/forms/elements/BaseInput';
  import { SIGNUP_VALIDATE_ACTION } from '@/store/modules/user/constants';
  // form rules
  import { rules } from '@/utils/asyncValidator/userProfileForm';
  //import Cookies from 'js-cookie';
  export default {
    components: { PasswordForm, UserProfileForm,AddressVueSelect, Button,Checkbox ,BaseInput  },
    props: {
      isDevMode: {
        type: Boolean,
        default: () => process.env.NODE_ENV === 'development'
      },
      sameAddress: {
        type: Boolean,
        default: false
      },
      details: {
        type: Object,
        default: null
      },
      rules: {
        type: Object,
        default: () => rules
      }
    },
    data() {
   
    const mailCheckValidator = (rule, value, callback) => {
       const {
          $refs: { profileForm },
        } = this;
          //console.log("value++"+JSON.stringify(value));
          //console.log("mail++"+JSON.stringify(profileForm.profile.mail));
          if (profileForm.profile.mail && !value) return callback(new Error('請再次確認您的E-mail'));
          const isEqual = profileForm.profile.mail === value;
          //console.log("isEqual"+isEqual);
          if (value && !isEqual) return callback(new Error('E-mail不相符'));
          callback();
            };
          const signupRules ={ 
            ...this.rules,     
                  reviewMail: [{ required: true, trigger: "blur", message: "請輸入您的 E-mail" },
                  { type: 'email', trigger: 'blur', message: '請輸入正確 E-mail 格式' },                      
                      { validator: mailCheckValidator ,required: true , trigger: "blur" }]
          }; 
          
      return {
        signupRules,
        password,
        profile: this.isDevMode ? devModel : profile,
        same: this.sameAddress,
      };
    },
    computed: {
      loading() {
        return this.$store.state.user.loading;
      },   
     
    },
    mounted() {
      window.scroll(0, 0);
      
    },   
    methods: {
      sameAsAddress() {
        const {
          $refs: { profileForm },
        } = this;
        if(this.same) {
          profileForm.profile.homeAddress = profileForm.profile.address;
        }
      },
      async initPartner(cid) {          
        const ccid= cid;   
        const config = generateAuthPostConf('tokenVerify',{ccid});
        const { data } = await axios(config);
        const {  message, success } = data; 
        //console.log("initPartner-partner:"+JSON.stringify(data.result));  
        if (!success)
        {}
        else{      
        this.details=data.result;
        //console.log("initPartner-partner1:"+JSON.stringify(this.details));   
        //this.details = reviews;
        //console.log("initPartner-partner1-1:"+JSON.stringify(this.details.customers_firstname));
       
        this.profile.name.firstName=this.details.customers_firstname;
        //this.devModel.name.firstName=this.details.customers_firstname;
        this.profile.name.lastName=this.details.customers_lastname;
        this.profile.identityNo= this.details.customers_identity;
        this.profile.phoneNo=this.details.customers_cell;
        if (this.details.customers_email_address!=undefined){
        this.profile.mail= this.details.customers_email_address; 
        }
        this.profile.RefAgent=this.details.ref_id;
        this.profile.dateOfBirth.year=new Date(this.details.customers_dob).year;
        this.profile.dateOfBirth.month=new Date(this.details.customers_dob).month;
        this.profile.dateOfBirth.day=new Date(this.details.customers_dob).day;        
        //("initPartner-partner2:"+JSON.stringify(profile)); 
        //console.log("initPartner-partner_devModel:"+JSON.stringify(devModel));

       // profileForm.profile.name.firstName=this.details.customers_firstname;
       // profileForm.profile.name.lastName=this.details.customers_lastname;
        }

      //  this.insuInfo=this.details[0];
      //  this.carProfile.carNo = this.details[0].carNo;
      //  this.type=this.carProfile.carNo.carType;
      //  this.red_url+=this.type+"/"+this.carProfile.carNo.block1+"-"+this.carProfile.carNo.block2;  //
      //  console.log("initRenewal-this.red_url"+JSON.stringify( this.red_url));      
       // console.log("initRenewal-this.insuInfo"+JSON.stringify( this.insuInfo));      
        //console.log("initRenewal-details"+JSON.stringify(this.details));            
      },
      async handleSubmit() {
        const { $refs: { passwordForm, profileForm }, $store } = this;
        const [password, profile] = await Promise.all([passwordForm.getPayload(), profileForm.getPayload()]);
        if (!password || !profile) return;
        $store.dispatch(SIGNUP_VALIDATE_ACTION, { ...profile, ...password });
      }
      
    }
  };
</script>
